module.exports = __webpack_public_path__ + "img/reserve-active.b8b69376.png";